"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METRICS_START = exports.METRICS_FID = exports.METRICS_LONGTASK = exports.METRICS_FCP = exports.METRICS_FP = exports.METRICS_LOAD = exports.METRICS_FSP = exports.METRICS_JS_ERROR = exports.METRICS_LCP = exports.METRICS_NETWORK = exports.METRICS_SCROLLFPS = exports.METRICS_RESOURCE_ERROR = exports.METRICS_RESOURCE = exports.METRICS_PV = exports.imgPattern = exports.cssPattern = exports.jsPattern = exports.SPA_PV = exports.CUSTOM_REPORT_URL = exports.CUSTOM_CATEGORY = exports.REPORT_URL = exports.CATEGORY = void 0;
/** 猎豹通道 category */
exports.CATEGORY = 'prism-report-web';
/** 猎豹通道 topic 域名 */
exports.REPORT_URL = 'https://prism-report-web.dreport.meituan.net';
/** 猎豹自定义指标 category */
exports.CUSTOM_CATEGORY = 'prism-report-custom';
/** 猎豹自定义通道 域名 */
exports.CUSTOM_REPORT_URL = 'https://prism-report-custom.dreport.meituan.net';
/** PV 变更事件 */
exports.SPA_PV = 'spa_pv';
exports.jsPattern = /\.js$/i;
exports.cssPattern = /\.css$/i;
exports.imgPattern = /\.(png|jpg|jpeg|gif|webp|ico|bmp|tiff|svg)$/i;
// 指标名列表
/* PV */
exports.METRICS_PV = 'web.pv';
/* 资源加载耗时 */
exports.METRICS_RESOURCE = 'web.resource';
/* 资源加载异常 */
exports.METRICS_RESOURCE_ERROR = 'web.resource.error';
/* 滚动FPS */
exports.METRICS_SCROLLFPS = 'web.scrollfps';
/* 网络耗时 */
exports.METRICS_NETWORK = 'web.http';
/* LCP */
exports.METRICS_LCP = 'web.startup.lcp';
/* JS 异常 */
exports.METRICS_JS_ERROR = 'web.jsError';
/* FSP */
exports.METRICS_FSP = 'FSP';
/* 页面加载时长 load event */
exports.METRICS_LOAD = 'web.startup.load';
/* 启动 FP */
exports.METRICS_FP = 'web.startup.fp';
/* 启动 FCP */
exports.METRICS_FCP = 'web.startup.fcp';
/* 页面运行时的 longtask */
exports.METRICS_LONGTASK = 'web.longtask';
/* 页面加载 first-input-delay： FID */
exports.METRICS_FID = 'web.fid';
/* 页面启动起点 */
exports.METRICS_START = 'web.startup.start';
//# sourceMappingURL=const.js.map